<template>
  <section class="-home-app-jumbotron hero is-medium -has-background-svg-02">
    <div class="hero-body">
      <div class="container">
        <h1
          class="title has-text-centered -has-text-massive -has-text-style-decorative"
        >
          OFFWORLD
        </h1>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AppJumbotron"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
